import { Badge } from "@/components/ui/badge";
import { CheckCircle, ShieldCheck } from "lucide-react";
import { QuoteForm } from "@/components/QuoteForm";

export const PhoneQuoteSection = () => (
  <section className="section-padding bg-white">
    <div className="container-custom">
      <div className="grid lg:grid-cols-2 gap-12">
        <div>
          <Badge className="bg-red-100 text-red-700 px-4 py-2 mb-4 hover:bg-red-100">Devis gratuit</Badge>
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">Demandez votre devis</h2>
          <p className="text-lg text-slate-600 mb-8">
            Décrivez votre problème et recevez une estimation sous 24h. Sans engagement.
          </p>

          <div className="rounded-2xl overflow-hidden shadow-xl mb-6">
            <img
              src="https://images.unsplash.com/photo-1746005514011-ea00280f3b6e?w=800"
              alt="Réparation iPhone en cours - composants"
              className="w-full h-64 object-cover"
              loading="lazy"
              width="800"
              height="256"
            />
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div className="bg-slate-50 rounded-xl p-4 flex items-center gap-3">
              <CheckCircle className="h-6 w-6 text-green-600 flex-shrink-0" />
              <span className="text-sm font-medium text-slate-700">Diagnostic gratuit</span>
            </div>
            <div className="bg-slate-50 rounded-xl p-4 flex items-center gap-3">
              <ShieldCheck className="h-6 w-6 text-blue-600 flex-shrink-0" />
              <span className="text-sm font-medium text-slate-700">Garantie 6 mois</span>
            </div>
          </div>
        </div>

        <QuoteForm />
      </div>
    </div>
  </section>
);
